import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// Single React 18 root for the whole app.
const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
